import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

const path = '/guides';
const url = `${OCTOPUS_BASE_URL}${path}`;

export const getEventsByGuideId = (guideId: string) => axios.get(`${url}/${guideId}/events`);
